import * as React from 'react'
import { Image, View, Text, TouchableOpacity, SafeAreaView } from 'react-native'
import styled from '@theme/styled-components'

import HeaderContent from './HeaderContent'

import useNavigation from '@layout/useNavigation'
import useReducer from '@store/useReducer'
import * as UserStore from '@store/user/user'

import useBreakpoint from '@utils/useBreakpoints'

const RootHeader = (props: HeaderProps) => {
  const navigation = useNavigation()
  const user = useReducer(UserStore.store, (s) => s.user)
  const [, bp] = useBreakpoint()

  if (!user) {
    return null
  }

  if (bp === 'phone') {
    return <HeaderContent {...props} />
  }

  const exposantDisplay = user.typeUtilisateur === 'EXPOSANT'

  return (
    <MainContainer>
      <SafeAreaView>
        <Row>
          {exposantDisplay && (
            <TouchableOpacity activeOpacity={0.8} onPress={() => navigation.push('/')}>
              <Logo source={require('@assets/logo_viparis_black.png')} />
            </TouchableOpacity>
          )}
          <FlexBox />
          <ContentContainer activeOpacity={0.8} onPress={() => navigation.push('/account')}>
            <Name>{`${user.prenom} ${user.nom}`}</Name>
            <Picture source={{ uri: '' }} />
          </ContentContainer>
        </Row>
      </SafeAreaView>
    </MainContainer>
  )
}

export default RootHeader

const MainContainer = styled(View)`
  padding: 15px;
  background-color: ${(props) => props.theme.colors.background};
  box-shadow: 0 4px 4px rgb(0 0 0 / 5%);
  z-index: 1;
`

const ContentContainer = styled(TouchableOpacity)`
  align-self: flex-end;
  flex-direction: row;
  align-items: center;
`

const Name = styled(Text)`
  ${(props) => props.theme.fonts.Subheadline};
  color: ${(props) => props.theme.colors.secondaryText};
  margin-right: 15px;
`

const Picture = styled(Image)`
  background-color: ${(props) => props.theme.colors.backgroundTertiary};
  height: 32px;
  width: 32px;
  border-radius: 16px;
`
const Logo = styled(Image)`
  width: 150px;
  height: 40px;
  align-self: center;
`
const Row = styled(View)`
  flex-direction: row;
  align-items: center;
  height: 32px;
`
const FlexBox = styled(View)`
  flex: 1;
`
